import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

import './Modal.css';

class Modal extends Component {
  componentDidMount() {
    this.modalTarget = document.createElement('div');

    document.body.appendChild(this.modalTarget);
    this._render();
  }

  componentWillUpdate() {
    this._render();
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(this.modalTarget);
    document.body.removeChild(this.modalTarget);
  }

  _render() {
    const {
      id, className, tabIndex, children, ...otherProps
    } = this.props;

    const classes = classNames(className, 'modal', 'fade');

    ReactDOM.render(
      <div
        id={id}
        className={classes}
        tabIndex={`${tabIndex || -1}`}
        role="dialog"
        aria-labelledby={id}
        aria-hidden
        {...otherProps}
      >
        <div className="modal-wrapper">
          <div className="modal-dialog" role="document">
            <div className="modal-content">{children}</div>
          </div>
        </div>
      </div>,
      this.modalTarget
    );
  }

  render() {
    return <noscript />;
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modals/Modal/Modal.js